export enum selfPrintingPersonaSettingsType {
  SELFPRINT = 'SELFPRINT',
  HANDSHAKE = 'HANDSHAKE'
}

export enum PersonaSettingsFlag {
  REGULAR_PERSONA = 'regular_persona'
}
